/**
 * @file Routes gameplay events to camera trauma (GDD §Fase 4 — pulido).
 *
 * Exists so that no gameplay system holds a reference to the camera: combat,
 * health and explosions all just emit `fx:shake`, and the mapping from event to
 * feel lives in one place that can be muted wholesale.
 */

import { System } from '../ecs/System.js';
import { Events } from '../core/EventBus.js';

export class CameraShakeSystem extends System {
  static priority = 94;

  constructor() {
    super();
    /** @type {(() => void)[]} @private */
    this._subscriptions = [];
  }

  /** @returns {void} */
  init() {
    this._subscriptions.push(
      this.ctx.events.on(Events.SHAKE, ({ amount }) => {
        this.ctx.cameraController.addTrauma(amount);
      })
    );
  }

  /** @returns {void} */
  dispose() {
    for (const unsubscribe of this._subscriptions) unsubscribe();
    this._subscriptions.length = 0;
  }
}
